import { Translation } from 'src/types/Translation';
import { ButtonComponent } from '../common/ButtonComponent';
import { StackComponent } from '../common/StackComponent';
import { usePermissionWrapper } from '../hooks/usePermissionWrapper';
import { useTab } from '../hooks/useTab';
import { useTranslations } from '../hooks/useTranslations';

export const TabOne: React.FC = () => {
  const translation = useTranslations({} as Translation, {}, 'acceptNext');
  const { setTabVal, tabVal, tabsData } = useTab();
  const currentTabinfo: any = tabsData.filter((item: any) => item.index === tabVal);
  const { checkPermission } = usePermissionWrapper();
  return (
    <>
      {checkPermission('view_startup_summary')
        ? currentTabinfo[0].NextButton && (
            <StackComponent spacing={2} direction="row" className="bottom-btn">
              <ButtonComponent
                variant="contained"
                onClick={() => {
                  setTabVal(tabVal + 1);
                }}
              >
                {translation.acceptNext}
              </ButtonComponent>
            </StackComponent>
          )
        : null}
      {/* // <iframe src="http://etmf-web-qa-1267953518.us-east-2.elb.amazonaws.com/?" width={800} height={500}></iframe>
      // </> */}
    </>
  );
};
